import { adminAuthClient , supabase } from './api'
import {getIdData} from "./profiles"




export async function createUser(email,pass,role) {

    const { data, error } = await adminAuthClient.createUser({
        email: email,
        password: pass,
        email_confirm: true,
        user_metadata: { role: role }
      })
      console.log("error",error);
      /*
    if (error) {
      throw new Error('Failed to fetch data')      
    }
*/
    return { data, error };
   
  }

  export async function updateRole(userId,role) {

    const { data, error } = await adminAuthClient.updateUserById({
        userId,
        email_confirm: true,
        user_metadata: { role: role }
      })

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
   
  }


  export async function signIn(user, pass) {
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email: user,
        password: pass,
      });
  
      if (error) {
        // console.error("Hata:", error.message);
        return { data: null, error }; // Hata durumunda null döndür
      }
  
      const userprofile = await getIdData(data.user.id);
      localStorage.setItem("eplus", JSON.stringify(userprofile));
  
      return { data, error: null }; // Başarılı durumda hatayı null yap
    } catch (e) {
      console.error("Beklenmeyen hata:", e.message);
      return { data: null, error: e }; // Beklenmeyen hata durumunda
    }
  }


  export async function forgotPass(email) {
    try {
      const { data, error } = await supabase.auth.resetPasswordForEmail(email);
      console.log("error", error);
      console.log("data", data);
      
      if (error) {
        console.error("Hata:", error);
        return { data: null, error }; // Hata durumunda null döndür
      }
  
      console.log("Data:", data);
  
      return { data, error: null }; // Başarılı durumda hatayı null yap
    } catch (e) {
      console.error("Beklenmeyen hata:", e.message);
      return { data: null, error: e }; // Beklenmeyen hata durumunda
    }
  }


export async function updateUser(newPassword)
{
let { data, error } = await supabase.auth.updateUser({ password: newPassword })

  return {data,error};
}


  export async function getUserId() {

    const { data, error } = await supabase.auth.getSession();

    //console.log("Session",data.session,error);

    if (error) {
    throw new Error('Failed to fetch data')
    }

    return data.session.user.id;
    
  }

  
  export async function signOut() {

    const { error } = await supabase.auth.signOut()

    localStorage.removeItem("companyId");
    localStorage.clear();
    sessionStorage.clear();
    if (error) {
    throw new Error('Failed to fetch data')
    }
    
  }


